import { combineReducers } from 'redux';

import {
  setOpenNoteInstructionModal,
  setNoteInstructionId,
  setUrlNoteInstruction,
  setInlineNoteInstruction,
} from '../actions';
import { ScriptEditorAction, NoteInstructionState } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof NoteInstructionState> = Reducer<NoteInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenNoteInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setNoteInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};

const url: ReducerOf<'url'> = (state = '', action) => {
  switch (action.type) {
    case setUrlNoteInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineNoteInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
  url,
});
